
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drill/[topicId]/[pageId]",
      function () {
        return require("private-next-pages/drill/[topicId]/[pageId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drill/[topicId]/[pageId]"])
      });
    }
  